import React, { Fragment } from 'react';

const AutoCompleteProductCard = (props) => {

    const {item} = props;

    return (
        <a className="small-12 large-6 columns" href={item.url}>
            <div className="autocomplete-card">
                    <div className="autocomplete-card__image-wrapper">
                        <img src={item.imageSource}/>
                    </div>
                    <div className="autocomplate-card__info-wrapper">
                        <h4>{item.name}</h4>
                    </div>
            </div>
        </a>
    );
}

export default AutoCompleteProductCard